import React, { useEffect, useState } from 'react';
import PageHeader from '../../components/Common/PageHeader/PageHeader';
import ServiceCard from '../../components/Sections/Services/ServiceCard/ServiceCard';
import axios from 'axios';

const Services = () => {

  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/service`);
        setServices(response.data.data || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <React.Fragment>
      <PageHeader title={"Services"} description={"What Services we Provide ?"} crums={[{
        label: "Services",
        path: "/services"
      }]} />
      <section>
        <div className='container py-16 space-y-10'>

          <div className="grid lg:grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-10" style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
            {loading ? (
              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <div className="spinner"></div>
              </div>
            ) : services.length === 0 ? (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <p className="text-gray-500">No services found.</p>
              </div>
            ) : (
              services.map((item, index) => <ServiceCard data={item} key={index} />)
            )}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default Services;